import {
  ref, onBeforeMount,
  Ref,
} from 'vue';
import { getAdobeTargetJson } from '../utils';
import { useAnalytics } from './useAnalytics';
import { useTags } from './useTags';
import { TagsType } from '../models/types/TagsType';

export default function useAdobeExperiment({
  adobeTargetLocation,
  tagControlIdentifier,
  tagVariantIdentifier,
}: {
  adobeTargetLocation: string;
  tagControlIdentifier?: TagsType;
  tagVariantIdentifier?: TagsType;
}): {
  adobeExperimentValue: Ref<string | undefined>;
} {
  const adobeExperimentResponse = ref<string | undefined>(undefined);

  onBeforeMount(async () => {
    try {
      adobeExperimentResponse.value = await getAdobeTargetJson([adobeTargetLocation]);
    } catch (error) {
      // Default to control experience if there's an error
      adobeExperimentResponse.value = 'A';
    }

    // If we'd like to send view tags for control / variant we can specify them
    // as parameters
    if (!tagControlIdentifier || !tagVariantIdentifier) return;

    const tagControl = useTags('getTag', tagControlIdentifier);
    const tagVariant = useTags('getTag', tagVariantIdentifier);

    useAnalytics('sendViewAnalytics', {
      pageName: adobeExperimentResponse.value === 'A' ? tagControl : tagVariant,
    });
  });

  return {
    adobeExperimentValue: adobeExperimentResponse,
  };
}
